import { intlService } from '~/i18n/IntlService';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  documentId: PilotId;
  reason?: string;
  extraDetails?: string;
}
export const deleteDocumentHandler = ({
  documentId,
  reason,
  extraDetails,
}: Request) => {
  try {
    return pilot.remove(`document/${documentId}/`, {
      data: { reason, extra_details: extraDetails },
    });
  } catch {
    throw new Error(
      intlService.getIntl().formatMessage({
        id: 'deleteDocumentHandler.deleteError',
        defaultMessage: 'An error occurred while deleting the document',
        description: 'Error message when document deletion fails',
      }),
    );
  }
};
